module.exports = __webpack_public_path__ + "img/weiter_handschrift_anim.1897b188.png";